import React from 'react'
import DetailDialog from '@/components/pages/DataInfoPage/DetailDialog'
import {SET_DATABASE_DETAIL} from '@/store/types'
import {useDispatch} from 'react-redux'
import {useQuery} from '@apollo/client'
import {DATABASE_QUERY} from '@/graphql/query/queries'
import {Box, CircularProgress} from '@mui/material'
import Typography from '@mui/material/Typography'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import DatabaseDetailContent from '@/components/pages/DataInfoPage/database/DatabaseDetailContent'

type DatabaseDetailDialogProps = {
    databaseId: string
}

/**
 * This dialog is always open.
 * Control its visibility from an outside component due to proper data resetting.
 */
const DatabaseDetailDialog = ({databaseId}: DatabaseDetailDialogProps) => {
    const dispatch = useDispatch()

    const {
        data,
        loading,
        error
    } = useQuery(DATABASE_QUERY, {variables: {databaseId}, notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only'})

    return (
        <DetailDialog open onClose={() => dispatch(SET_DATABASE_DETAIL(undefined))}
            header={'DATABASE: ' + databaseId}>
            {loading && (<Box
                width="100%"
                alignItems="center"
                justifyContent="center"
                display="flex"
                flexDirection="column">
                <CircularProgress size="2em"/>
            </Box>)}
            {!!error && (<Box
                width="100%"
                alignItems="center"
                justifyContent="center"
                display="flex"
                flexDirection="column">
                <ErrorOutlineIcon color="error" fontSize="large"/>
                <Typography>Unable to get database with id: {databaseId}</Typography>
            </Box>)}
            {!!data && (<DatabaseDetailContent database={data.database}/>)}
        </DetailDialog>
    )
}

export default DatabaseDetailDialog